const DEFAULT_TTL_MS = 10 * 60 * 1000; // 10 minutos

const cache = new Map();

export function getCachedBarbers(maxAgeMs = DEFAULT_TTL_MS) {
    const entry = cache.get('__all__');
    if (!entry) return null;

    const isFresh = Date.now() - entry.fetchedAt <= maxAgeMs;
    if (!isFresh) {
        cache.delete('__all__');
        return null;
    }

    return entry.data;
}

export function setCachedBarbers(data) {
    if (!Array.isArray(data)) return;
    cache.set('__all__', {
        data,
        fetchedAt: Date.now()
    });
}

export function invalidateBarbersCache() {
    cache.delete('__all__');
}

export async function loadBarbers(apiBaseUrl, mapBarber) {
    const cached = getCachedBarbers();
    if (cached) return cached;

    const response = await fetch(`${apiBaseUrl}/barber/barbers`);
    if (!response.ok) {
        throw new Error('Error al cargar los barberos');
    }

    const data = await response.json();
    const mapped = (data || []).map(mapBarber);
    setCachedBarbers(mapped);
    return mapped;
}
